import { appUrls } from "../../../EasyProjectsCommon/AppUrls";
import { OAuthClient } from "../../../EasyProjectsCommon/OAuthClient";
import { Annotation } from "../actions";

export const imageAnnotationApi = {
    saveAnnotation(data: Annotation): PromiseLike<number> {
        return OAuthClient.postJson(appUrls.annotations.create, data).then(x => x);
    },
};
